enum MessageType {
  /* eslint-disable no-restricted-syntax */
  USER_FINISH_REQUEST = 'hellosign:userFinishRequest',
  APP_ERROR = 'hellosign:error',
  /* eslint-enable no-restricted-syntax */
}
export const messages = MessageType;

export type AppError = {
  type: MessageType.APP_ERROR;
  payload: {
    // Every place in the code I found hellosign:error, it's passing undefined here :shrug:
    signatureId: undefined;
    code: 'nothing_to_sign' | 'unknown';
  };
};

export type MessagesWithData = AppError;

export type LookupMessageType<T extends MessageType> =
  T extends MessagesWithData['type']
    ? Extract<MessagesWithData, { type: T }>
    : { type: T };

/**
 * Natively sends a cross-origin window message if the
 * user's navigator supports it, otherwise fails silently.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
 * @param {any} message
 * @param {string} targetOrigin
 * @param {Transferable} [transfer]
 * @returns {void}
 */
export function postMessage<T extends MessageType>(
  message: LookupMessageType<T>,
  targetOrigin: string,
  transferrable?: Transferable[] | undefined,
) {
  if (!targetOrigin) {
    return;
  }

  // Tests will never actually have a parent in JSDOM
  /* istanbul ignore next */
  if (window.parent) {
    window.parent.postMessage(message, targetOrigin, transferrable);
  }
}
